module.exports = __webpack_public_path__ + "img/thumbnail_channel_beam.1faeb784.png";